import { Navigate, Route, Routes } from "react-router-dom";

// components
import HeaderStats from "components/Headers/HeaderStats.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

// views
import Worker from "views/admin/Worker.js";

export default function History() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">

          <Routes>
            {/* <Route path="/" element={<Worker />} /> */}
            {/* Uncomment when needed */}
            {/* <Route path="leads" element={<Leads />} />
              <Route path="chats" element={<Chats />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
